import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpService from "../../services/httpService";
import { notify } from "../utils/methods/notification";


const initialState = {
    isLoading: false,
    AllDisclaimers: [],
};
//@info it is for fetching all disclaimers
export const fetchAllDisclaimers = createAsyncThunk(
    'bmr/fetchAllDisclaimers',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getListDisclaimers', { params: payload });
            return response; 
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
//@ info this is for creating disclaimer 
export const createDisclaimer = createAsyncThunk(
    'disclaimer/create',
    async (args, { rejectWithValue }) => {
        try {
            const response = await httpService.post('/createDisclaimers', args)
            notify.success(response.message);
            return response.data;

        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
//@info it is for roles list 
export const fetchdisclaimerRoles = createAsyncThunk(
    'disclaimer/fetchRoles',
    async (_, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/rolesList')
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
export const deleteDisclaimer = createAsyncThunk(
    'bmr/deleteDisclaimer',
    async (args, { rejectWithValue }) => {
        try {
            const { id } = args;
            const response = await httpService.delete(`/deleteDisclaimers/${id}`);
            notify.success(response?.data?.message || "Deleted successfully");
            return response.data;
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            notify.error(message);
            return rejectWithValue(message);
        }
    }
);
//@info for editing disclaimer 
export const updateDisclaimer = createAsyncThunk(
    'disclaimer/updateDisclaimer',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id, data } = args;
            const response = await httpService.put(`/updateDisclaimers/${id}`, data);
            notify.success(response?.data?.message || response?.message || "Updated successfully");
            dispatch(fetchAllDisclaimers({ page: 1, per_page: 10 }));
            return response.data;
        } catch (error) {
            notify.error(error?.message || "Something went wrong");
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
//@info this is for modal
export const getAccessDisclaimer = createAsyncThunk(
    'access/getAccessDisclaimer',
    async (_, { rejectWithValue }) => {
        try {
            const response = await httpService.get('/getAccessdisclaimer');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
const DisclaimerSlice = createSlice({
    name: "disclaimer",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllDisclaimers.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllDisclaimers.fulfilled, (state, action) => {
                state.isLoading = false;
                state.AllDisclaimers = action.payload
            })
            .addCase(fetchAllDisclaimers.rejected, (state) => {
                state.isLoading = false;
            })
            //@info slice for create disclaimer
            .addCase(createDisclaimer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createDisclaimer.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(createDisclaimer.rejected, (state) => {
                state.isLoading = false;
            })
             //@info slice for roles list 
            .addCase(fetchdisclaimerRoles.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchdisclaimerRoles.fulfilled, (state, action) => {
                state.isLoading = false;
                state.roles = action.payload;
            })
            .addCase(fetchdisclaimerRoles.rejected, (state) => {
                state.isLoading = false;
            })
             //@info slice for deleting
            .addCase(deleteDisclaimer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDisclaimer.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.AllDisclaimers?.data) {
                    state.AllDisclaimers.data = state.AllDisclaimers.data.filter(
                        item => item.id !== action.meta.arg.id
                    )
                    state.AllDisclaimers.page_details.total_records -= 1
                }
            })
            .addCase(deleteDisclaimer.rejected, (state) => {
                state.isLoading = false;
            })
            //@info for modifying disclaimer 
            .addCase(updateDisclaimer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDisclaimer.fulfilled, (state, action) => {
                state.isLoading = false;
                if (state.currentDisclaimer?.id === action.payload.id) {
                    state.currentDisclaimer = action.payload;
                }
            })
            .addCase(updateDisclaimer.rejected, (state) => {
                state.isLoading = false;
            })
            //@info for showing modal on dashboard 
            .addCase(getAccessDisclaimer.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAccessDisclaimer.fulfilled, (state, action) => {
                state.isLoading = false;
                state.disclaimerData = action.payload;
            })
            .addCase(getAccessDisclaimer.rejected, (state) => {
                state.isLoading = false;
            })
    }
});
export default DisclaimerSlice.reducer;